/**
 * TanStack Query hooks for `igaming-pricing-separate-fully-custom`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingPricingSeparateFullyCustomQueryKeys,
	type CreateIgamingPricingSeparateFullyCustomBody,
	type ListIgamingPricingSeparateFullyCustomResponse,
	type IgamingPricingSeparateFullyCustomRow,
} from "./api";

export function useIgamingPricingSeparateFullyCustomList(): UseQueryResult<ListIgamingPricingSeparateFullyCustomResponse, Error> {
	return useQuery({
		queryKey: igamingPricingSeparateFullyCustomQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingPricingSeparateFullyCustomCreate(): UseMutationResult<IgamingPricingSeparateFullyCustomRow, Error, CreateIgamingPricingSeparateFullyCustomBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingPricingSeparateFullyCustomQueryKeys.all });
		},
	});
}

export function useIgamingPricingSeparateFullyCustomDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingPricingSeparateFullyCustomQueryKeys.all });
		},
	});
}
